import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import { ResponsiveBar } from '@nivo/bar';
import { Md5 } from 'ts-md5';

/**
 * Props
 *
 */
type Props = {
  dataAnalyticsTempoAtendimentos: DataAnalyticsTempoAtendimentos[],
};

/**
 * State
 *
 */
type State = {
  hashProps: string,
  hasData: boolean,
};

/**
 * Data chart pacientes
 *
 */
interface DataAnalyticsTempoAtendimentos {
  minimo: number;
  medio: number;
  maximo: number;
}

/**
 * Chart Dashboard Component
 *
 */
class ChartTempoAtendimentosAnalyticsDashboardComponent extends React.Component<
  Props,
  State
> {
  /**
   * Default constructor
   *
   * @param props
   */
  constructor(props: any) {
    super(props);
    this.state = this.getInitialState();
  }

  /**
   * Responsible change componente.
   *
   * @param prevProps
   * @param prevState
   * @param snapshot
   */
  componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<any>,
    snapshot?: any
  ): void {
    let newHashProps: string = this.generateHasProps(
      this.props.dataAnalyticsTempoAtendimentos
    );
    if (newHashProps !== prevState.hashProps) {
      this.setState(this.getInitialState());
    }
  }

  /**
   * Responsible get initial state
   *
   * @return {}
   */
  getInitialState(): any {
    return {
      hashProps: this.generateHasProps(
        this.props.dataAnalyticsTempoAtendimentos
      ),
      hasData: this.hasData(),
    };
  }

  /**
   * Responsible generate hash.
   *
   * @param dataAnalyticsTempoAtendimentos
   * @return {string}
   */
  generateHasProps = (
    dataAnalyticsTempoAtendimentos: DataAnalyticsTempoAtendimentos[]
  ): string => {
    return Md5.hashStr(JSON.stringify(dataAnalyticsTempoAtendimentos));
  };

  /**
   *
   * Responsible validate if has data.
   *
   * @return {boolean}
   */

  hasData = (): boolean => {
    return (
      this.props.dataAnalyticsTempoAtendimentos &&
      this.props.dataAnalyticsTempoAtendimentos.length > 0
    );
  };

  // /**
  //  * Responsible get legend label
  //  *
  //  * @returns {string}
  //  */
  getLegendLabel(): string {
    if (
      this.props.dataAnalyticsTempoAtendimentos &&
      this.props.dataAnalyticsTempoAtendimentos[0] &&
      this.props.dataAnalyticsTempoAtendimentos[0].period
    ) {
      if (this.props.dataAnalyticsTempoAtendimentos[0].period.length === 10) {
        return 'Dias';
      } else if (
        this.props.dataAnalyticsTempoAtendimentos[0].period.length === 7
      ) {
        return 'Meses';
      } else {
        return 'Anos';
      }
    } else {
      return '';
    }
  }

  /**
   * Responsible get color anality data
   *
   * @param id - id
   * @param data - data
   * @returns {string}
   */
  getColorAnalyticData(id, data) {
    if (id && data) {
      switch (id) {
        case 'maximo':
          return '#606C38';
        case 'minimo':
          return '#02457A';
        case 'medio':
          return '#BC4B0D';
      }
    }
  }

  /**
   * Responsible format date.
   *
   * @param datum
   * @return {string}
   */
  formatDateIndex = (datum: RawDatum): string => {
    if (datum && datum.period) {
      let splitDate: Array<string> = datum.period.split('-');
      if (splitDate.length > 1) {
        let finalDate: string = '';
        splitDate
          .slice()
          .reverse()
          .forEach((value, index, array) => {
            finalDate += value + (index + 1 < array.length ? '/' : '');
          });
        return finalDate;
      }
    }
    return '';
  };

  /**
   * Render component
   *
   * @returns {JSX.Element}
   */
  render() {
    return (
      <React.Fragment>
        <Card className="bg-light h-100">
          <Card.Body className="chart-card-body">
            <Card.Title className="chart-card-title d-flex justify-content-center">
              {this.props.titleDash}
            </Card.Title>
            {!this.state.hasData && (
              <React.Fragment>
                <div className="chart-text-blank justify-content-center">
                  Não existem dados a serem exibidos para essa pesquisa.
                </div>
              </React.Fragment>
            )}
            {this.state.hasData && (
              <React.Fragment>
                <div className="chart-card-full">
                  <ResponsiveBar
                    keys={['minimo', 'medio', 'maximo']}
                    margin={{ top: 60, right: 110, bottom: 70, left: 80 }}
                    indexBy={this.formatDateIndex}
                    padding="0.2"
                    labelTextColor="inherit:darker(1.4)"
                    labelSkipHeight="16"
                    labelSkipWidth="16"
                    legends={[
                      {
                        dataFrom: 'keys',
                        anchor: 'bottom-right',
                        direction: 'column',
                        toggleSerie: true,
                        justify: false,
                        translateX: 120,
                        translateY: 0,
                        itemsSpacing: 2,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: 'left-to-right',
                        itemOpacity: 0.85,
                        symbolSize: 20,
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: -63,
                      legend: this.getLegendLabel(),
                      legendPosition: 'end',
                      legendOffset: 50,
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Quantidade',
                      legendPosition: 'end',
                      legendOffset: -60,
                    }}
                    data={this.props.dataAnalyticsTempoAtendimentos}
                    height="500"
                    colors={{ scheme: this.props.scheme }}
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                  />
                </div>
              </React.Fragment>
            )}
          </Card.Body>
        </Card>
      </React.Fragment>
    );
  }
}

/**
 * Export default connect
 *
 */
export default connect(
  null,
  null,
  null
)(ChartTempoAtendimentosAnalyticsDashboardComponent);
